import { render } from "./MainList.vue?vue&type=template&id=7b4a8704"
import script from "./MainList.vue?vue&type=script&lang=js"
export * from "./MainList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__